// ANALYTICS - TRACKERS
import { init as initMenu } from './../trackers/customer/menu-tracker';
import { init as initDashboardTracker } from './../trackers/customer/dashboard-tracker';
import { init as initReturn } from './../trackers/customer/return-tracker';
import { init as initProfileTracker } from './../trackers/customer/profile-tracker';
import { init as initPurchases } from './..//trackers/customer/purchases-tracker';
import { init as initAddressBook } from './../trackers/customer/address-book-tracker';
import { init as initStore } from './../trackers/customer/store-tracker';
import { init as initSubscriptionTracker } from './../trackers/customer/subscription-tracker';
// SHOPPING TOOL
import { init as initStDashboard } from './../shopping-tool/st-dashboard';

export const init = () => {
  if ( window.cube.config.anly_useLegacy === 'Y') {
    // Initialisation des trackers
    if ($('body').hasClass('account')) {
      initMenu();
      initDashboardTracker();
      initReturn();
    }
    if ($('.profile-container').length) initProfileTracker();
    if (
      $('.ua-container').hasClass('purchases') ||
      $('#order-detail-page').length
    )
      initPurchases();
    if ($('#address-book').length) initAddressBook();
    if ($('#mystore-page').length) initStore();
    if ($('#my-subscriptions')) initSubscriptionTracker();

    // Init Shopping tools
    initStDashboard();
  }
};



// WEBPACK FOOTER //
// ./src/analytics/routes/customer.anly.route.js